// views
import { Avatar } from "antd";
import UserAvatar from "~/components/user/UserAvatar";

// utils
import _ from "lodash";

const STYLE = {
  marginLeft: "-15px",
  border: "2px solid white",
  position: "relative",
  borderRadius: "50%",
  display: "inline-block",
};

export default (props) => {
  const showCount = props.showCount || 3;
  const hasMore = props.chargesCount > showCount;
  const charges = _.take(props.charges, showCount);

  const chargesCount = props.chargesCount > 999 ? "999+" : props.chargesCount;

  const renderMore = (
    <div style={STYLE}>
      <Avatar
        className="more-charges"
        size={40}
      >
        <span
          style={{
            fontFamily: "MiSans",
            fontWeight: "630",
            fontSize: 20,
            padding: "3px",
          }}
        >
          {chargesCount}
        </span>
      </Avatar>
    </div>
  );

  return (
    <div className="text-left">
      <div style={{ paddingLeft: "15px" }}>
        {charges.map((charge) => (
          <UserAvatar
            user={charge.user}
            size={40}
            key={`${Date.now()}-${charge.id}`}
            style={STYLE}
          />
        ))}
        {hasMore && renderMore}
      </div>
    </div>
  );
};
